module.exports = __webpack_public_path__ + "static/media/react_icon.05a3e30f.svg";